<template>
    <div class="category-wrap">
        <div class="category-breadcrumb">
            <div class="category-breadcrumb__lists">
                <div class="category-breadcrumb__list" v-for="(item, index) in values" :key="`parents-${index}-${item._id}`">
                    <select :value="item._id" @change="goCategory">
                        <option v-for="option in options[index]" :key="`parent-${index}-option-${option._id}`" :value="option._id">
                            {{ option.name }}
                        </option>
                    </select>
                    <span v-html="icon" style="margin:0 0.5em; fill:#ccc;" v-if="!(index == values.length - 1 && !hasNextGeneration)"></span>
                </div>
                <div class="category-breadcrumb__list" v-if="hasNextGeneration">
                    <select :value="_category" @change="goCategory">
                        <option v-for="root in categories_nextGeneration" :key="`sibling-${root._id}`" :value="root._id">
                            {{ root.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    
    <!-- <div class="category-breadcrumb">
        <ul class="category-breadcrumb__lists">
            <li class="category-breadcrumb__list" v-for="(item, index) in values" :key="`parents-${index}-${item._id}`">
                <select :value="item._id" @change="goCategory">
                    <option v-for="option in options[index]" :key="`parent-${index}-option-${option._id}`" :value="option._id">
                        {{ option.name }}
                    </option>
                </select>
                <span v-html="icon" style="margin:0 0.5em;" v-if="!(index == values.length - 1 && !hasNextGeneration)"></span>
            </li>
            <li class="category-breadcrumb__list" v-if="hasNextGeneration">
                <select :value="_category" @change="goCategory">
                    <option v-for="root in categories_nextGeneration" :key="`sibling-${root._id}`" :value="root._id">
                        {{ root.name }}
                    </option>
                </select>
            </li>
        </ul>
    </div> -->
</template>

<script>
import { mapState } from "vuex";
export default {
    props: {
        _category: String,
    },
    data() {
        return {
            icon: '<svg class="icon" x="0px" y="0px" viewBox="0 0 8.1 16"><polygon points="1.5,16 0,14.7 5.5,8 0,1.3 1.5,0 8.1,8"/></svg>',
        };
    },
    computed: {
        ...mapState("shop", { categories: (state) => state.categories }),
        categories_children() {
            return this.categories.flatMap(({ children }) => children);
        },
        categories_grandChildren() {
            return this.categories_children.flatMap(({ children }) => children);
        },
        categories_granderChildren() {
            return this.categories_grandChildren.flatMap(({ children }) => children);
        },
        categories_grandestChildren() {
            return this.categories_granderChildren.flatMap(({ children }) => children);
        },
        category() {
            return this.getCategory(this.categories) ?? this.getCategory(this.categories_children) ?? this.getCategory(this.categories_grandChildren) ?? this.getCategory(this.categories_granderChildren);
        },
        depth() {
            return this.category?.depth || 0;
        },
        parent() {
            const { depth } = this;

            switch (depth) {
                case 2:
                    return this.categories.find(({ _id }) => this.category._parents.includes(_id));
                case 3:
                    return this.categories_children.find(({ _id }) => this.category._parents.includes(_id));
                case 4:
                    return this.categories_grandChildren.find(({ _id }) => this.category._parents.includes(_id));
            }
        },
        grandParent() {
            const { depth } = this;

            switch (depth) {
                case 3:
                    return this.categories.find(({ _id }) => this.parent._parents.includes(_id));
                case 4:
                    return this.categories_children.find(({ _id }) => this.parent._parents.includes(_id));
            }
        },
        granderParent() {
            const { depth } = this;

            switch (depth) {
                case 4:
                    return this.categories.find(({ _id }) => this.parent._parents.includes(_id));
                case 5:
                    return this.categories_children.filter(({ _parents }) => _parents.includes(this.granderParent._id));
            }
        },
        grandestParent() {
            const { depth } = this;

            switch (depth) {
                case 5:
                    return this.categories.find(({ _id }) => this.parent._parents.includes(_id));
            }
        },
        values() {
            return [this.grandestParent, this.granderParent, this.grandParent, this.parent, this.category].filter((item) => item);
        },
        categories_nextGeneration() {
            const { depth } = this;
            const showAll = { name: "전체보기", _id: this._category };
            switch (depth) {
                case 0:
                    return [showAll, ...this.categories];
                case 1:
                    return [showAll, ...this.categories_children.filter(({ _parents }) => _parents.includes(this.category._id))];
                case 2:
                    return [showAll, ...this.categories_grandChildren.filter(({ _parents }) => _parents.includes(this.category._id))];
                case 3:
                    return [showAll, ...this.categories_granderChildren.filter(({ _parents }) => _parents.includes(this.category._id))];
                case 4:
                    return [showAll, ...this.categories_grandestChildren.filter(({ _parents }) => _parents.includes(this.category._id))];
            }
        },
        categories_siblings() {
            const { depth } = this;
            const showAll = { name: "전체보기", _id: this.parent?._id };
            switch (depth) {
                case 1:
                    return [showAll, ...this.categories];
                case 2:
                    return [showAll, ...this.categories_children.filter(({ _parents }) => _parents.includes(this.parent._id))];
                case 3:
                    return [showAll, ...this.categories_grandChildren.filter(({ _parents }) => _parents.includes(this.parent._id))];
                case 4:
                    return [showAll, ...this.categories_granderChildren.filter(({ _parents }) => _parents.includes(this.parent._id))];
                case 5:
                    return [showAll, ...this.categories_grandestChildren.filter(({ _parents }) => _parents.includes(this.parent._id))];
            }
        },
        categories_parents() {
            const { depth } = this;
            const showAll = { name: "전체보기", _id: this.grandParent?._id };
            switch (depth) {
                case 2:
                    return [showAll, ...this.categories];
                case 3:
                    return [showAll, ...this.categories_children.filter(({ _parents }) => _parents.includes(this.grandParent._id))];
                case 4:
                    return [showAll, ...this.categories_grandChildren.filter(({ _parents }) => _parents.includes(this.grandParent._id))];
                case 5:
                    return [showAll, ...this.categories_granderChildren.filter(({ _parents }) => _parents.includes(this.grandParent._id))];
            }
        },
        categories_grandParents() {
            const { depth } = this;
            const showAll = { name: "전체보기", _id: this.granderParent?._id };

            switch (depth) {
                case 3:
                    return [showAll, ...this.categories];
                case 4:
                    return [showAll, ...this.categories_children.filter(({ _parents }) => _parents.includes(this.granderParent._id))];
                case 5:
                    return [showAll, ...this.categories_grandChildren.filter(({ _parents }) => _parents.includes(this.granderParent._id))];
            }
        },
        categories_granderParents() {
            const { depth } = this;
            const showAll = { name: "전체보기", _id: this.grandestParent?._id };
            switch (depth) {
                case 4:
                    return [showAll, ...this.categories];
                case 5:
                    return [showAll, ...this.categories_children.filter(({ _parents }) => _parents.includes(this.grandestParent._id))];
            }
        },
        categories_grandestParents() {
            const { depth } = this;

            switch (depth) {
                case 5:
                    return [{ name: "전체보기", _id: undefined }, ...this.categories];
            }
        },
        options() {
            return [this.categories_grandestParents, this.categories_granderParents, this.categories_grandParents, this.categories_parents, this.categories_siblings].filter((item) => item);
        },
        hasNextGeneration() {
            return this.categories_nextGeneration?.length > 1;
        },
    },
    methods: {
        getCategory(categories) {
            return categories.find(({ _id }) => _id == this._category);
        },
        goCategory(event) {
            this.$router.push(`/shop/categories/${event.target.value}`);
        },
        init(){
            
        }
    },
};
</script>
<style lang="scss" scoped>

@media (min-width: 1025px) {
    .category-breadcrumb {
        display: none;
    }
}
@media (max-width: 1024px) {
    .category-breadcrumb {
        margin: 0 -15px;
        padding: 13px 15px;
        border-bottom: 10px solid #ececec;
        overflow-x: auto;
        &__lists {
            display: flex;
            align-items: center;
            list-style: none;
            line-height: 1;
        }
        &__list {
            display: flex;
            align-items: center;
            width:140px;
            // display: inline-block;
            // vertical-align: middle;
            // margin-right: 2px;
        }
        &__list .link {
            line-height: 1;
            font-size: 13px;
        }
        &__list ::v-deep .icon {
            margin-left: 2px;
            width: 8px;
            height: 8px;
        }
    }
    .category-breadcrumb__lists {min-width:600px;}
    .category-breadcrumb__list select {width:120px; border:none; border-radius:0; -webkit-appearance:none; -moz-appearance: none; appearance: none; position:relative;}
    
}
@media (max-width: 768px){
    .category-breadcrumb {padding:8px 15px;}
}
</style>
